import { ServiceData } from '@/types';

import articles from './YOGA_ARTICLES_HR.json';
import exercises from './YOGA_EXERCISES_HR.json';
import recipes from './YOGA_RECIPES_HR.json';

export const YOGA_DATA_HR: ServiceData = {
  articles,
  exercises,
  recipes,
};
